import React from "react";
import {useFormContext} from 'react-hook-form'

const TextareaBase = (props) => {
    const {register} = useFormContext()
    return (
        <textarea 
            {...props}
            {...register(props.name)}
            className="w-full bg-lavender-8 rounded-2xl border-none foces:border-none text-lavender font-semibold placeholder:text-lavender-60 placeholder:font-semibold px-6 py-4 text-[1.125rem]" 
        ></textarea>
    )
}

export default TextareaBase